import instance from '../lib/axios'

const PATH = '/recruits'

export const postRecruits = (data: {name: string; nickname: string; password: string}) =>
  instance({method: 'post', url: PATH, data})

export const getRecruits = (params: {start: number; perPage: number; search?: string}) =>
  instance({method: 'get', url: PATH, params})

export const getRecruit = (id: number | string) => instance({method: 'get', url: PATH + '/' + id})

export const patchRecruit = (
  id: number | string,
  data: {
    name?: string
    nickname?: string
    password?: string
  }
) => instance({method: 'patch', url: PATH + '/' + id, data})

export const deleteRecruits = (id: number | string) => instance({method: 'delete', url: PATH + '/' + id})
